import { NgModule } from '@angular/core';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';

@NgModule({
  imports: [BreadcrumbComponent],
  exports: [BreadcrumbComponent],
})
export class AppBreadcrumbModule {}
